import { useMutation } from '@tanstack/react-query';
import api from '../../http';
import { useForBindingId } from '../../../forBinding';
import { getApiErrorMessage, toApiError } from '../utils';
import type { ExportFieldDiaryParams, FieldDiaryRequestOptions } from './types';

export const useExportFieldDiary = ({
	forBinding: ownerForBinding,
}: FieldDiaryRequestOptions = {}) => {
	const contextForBinding = useForBindingId();
	const forBinding = ownerForBinding ?? contextForBinding;

	return useMutation({
		mutationFn: async (params: ExportFieldDiaryParams) => {
			try {
				const { data } = await api.get<Blob>('/field-diary/export', {
					responseType: 'blob',
					params: { forBinding, ...params },
				});
				return data;
			} catch (error) {
				throw toApiError(error, 'Erro ao exportar o diário de campo');
			}
		},
		onError: (error) =>
			console.error(
				'Erro ao exportar o diário de campo:',
				getApiErrorMessage(error, 'Erro ao exportar o diário de campo')
			),
	});
};
